import React from 'react'

import { EditOutlined } from '@ant-design/icons'
import { Button, Col, Divider, Row, Space, Tag, Typography } from 'antd'

import { BillingSubscription } from '@pollination-solutions/pollination-sdk'

type PaymentMethodInfo = {
  type: string
  card?: any
  createdAt: string
} | null

type Props = {
  subscription: BillingSubscription
  subscriptionTotal: string
  subscriptionBillingFrequency: 'monthly' | 'yearly'
  latestPaymentMethod: PaymentMethodInfo
  onUpdatePaymentMethod: () => void
}

export const SubscriptionOverview: React.FC<Props> = ({
  subscription,
  subscriptionBillingFrequency,
  latestPaymentMethod,
  subscriptionTotal,
  onUpdatePaymentMethod
}) => {
  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <Row style={{ width: '100%' }}>
        <Col xs={9} sm={8} md={6} lg={6} xl={5} xxl={4}>
          <Typography.Text strong>Status: </Typography.Text>
        </Col>
        <Col>
          <Tag color={subscription.status === 'active' 
            ? 'green' : 'orange'}>{subscription.status.toUpperCase()}</Tag>
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ width: '100%' }}>
        <Col xs={9} sm={8} md={6} lg={6} xl={5} xxl={4}>
          <Typography.Text strong>Billing Frequency: </Typography.Text>
        </Col>
        <Col>
          <Typography.Text>
            {subscriptionBillingFrequency === 'yearly' ? 'Yearly' : 'Monthly'}
          </Typography.Text>
        </Col>
      </Row>
      {subscription.next_billed_at && (
        <Row gutter={[16, 16]} style={{ width: '100%' }}>
          <Col xs={9} sm={8} md={6} lg={6} xl={5} xxl={4}>
            <Typography.Text strong>Next Payment Due: </Typography.Text>
          </Col>
          <Col>
            <Typography.Text>{new Date(subscription.next_billed_at).toLocaleDateString()}</Typography.Text>
          </Col>
        </Row>
      )}
      {latestPaymentMethod && (
        <Row gutter={[16, 16]} style={{ width: '100%' }}>
          <Col xs={9} sm={8} md={6} lg={6} xl={5} xxl={4}>
            <Typography.Text strong>Payment Method: </Typography.Text>
          </Col>
          <Col>
            <Space>
              {latestPaymentMethod.type === 'card' && latestPaymentMethod.card ? (
                <Typography.Text>
                  {/* @ts-ignore */}
                  {latestPaymentMethod.card.type?.toUpperCase()} ending in {latestPaymentMethod.card.last4}
                </Typography.Text>
              ) : latestPaymentMethod.type === 'paypal' ? (
                <Typography.Text>PayPal</Typography.Text>
              ) : (
                <Typography.Text style={{ textTransform: 'capitalize' }}>
                  {latestPaymentMethod.type}
                </Typography.Text>
              )}
              <Button
                // type="primary"
                type="link"
                icon={<EditOutlined />}
                size="small"
                onClick={onUpdatePaymentMethod}
              >
                Change Payment Method
              </Button>
            </Space>
            </Col>
        </Row>
      )}
      {subscription.collection_mode === 'manual' && (
        <Row gutter={[16, 16]} style={{ width: '100%' }}>
          <Col xs={9} sm={8} md={6} lg={6} xl={5} xxl={4}>
            <Typography.Text strong>Payment Method: </Typography.Text>
            <Typography.Text type="secondary">Invoice</Typography.Text>
          </Col>
        </Row>
      )}
      <Row gutter={[16, 16]} style={{ width: '100%' }}>
        <Col xs={9} sm={8} md={6} lg={6} xl={5} xxl={4}>
          <Typography.Text strong>Total Cost: </Typography.Text>
        </Col>
        <Col>
          <Typography.Title level={5} type='success' style={{ display: 'inline', margin: 0 }}>
            {subscriptionTotal} + VAT/Tax
          </Typography.Title>
        </Col>
      </Row>
    </Space>
  )
}
